import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({
  theme: 'light',
  toggleTheme: () => {},
  setTheme: () => {},
});

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    // Check for saved theme preference, default to light
    const savedTheme = localStorage.getItem('ff-theme');
    return savedTheme || 'light';
  });

  useEffect(() => {
    // Apply theme to document body
    document.body.setAttribute('data-theme', theme);
    
    // Save theme preference
    localStorage.setItem('ff-theme', theme);
    
    // Cleanup function to ensure proper theme application
    return () => {
      document.body.removeAttribute('data-theme');
    };
  }, [theme]);

  const setTheme = (newTheme) => {
    if (newTheme === 'light' || newTheme === 'dark') {
      setThemeState(newTheme);
    }
  };

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const value = {
    theme,
    setTheme,
    toggleTheme,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;